
export default (account, discount) => {
  if(!account) {
    return Number(discount['sgh'])
  }

  return Number(discount[account.type])
}